/**
 *  BOM 模块
 *  @module utils/bom
 */

/**
 * 浏览器全屏
 * @param {HTMLElement} [el=document] 全屏元素
 */
export function browserFullScreen(el) {
  el = el || document.documentElement
  const rfs = el.requestFullScreen || el.webkitRequestFullScreen || el.mozRequestFullScreen || el.msRequestFullscreen
  if (typeof rfs !== 'undefined' && rfs) {
    rfs.call(el)
  }
}

/**
 * 退出全屏
 */
export function browserExitFullScreen() {
  if (document.exitFullscreen) {
    document.exitFullscreen()
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen()
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen()
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen()
  }
}

/**
 * 浏览器当前是否全屏
 * @return {*|boolean}
 */
export function browserIsFullScreen() {
  return !!(document.webkitIsFullScreen || (
    document.fullscreenElement ||
    document.webkitFullscreenElement ||
    document.msFullscreenElement ||
    document.mozFullScreenElement ||
    null))
}



// WEBPACK FOOTER //
// ./src/utils/bom.js